
/* eslint-disable @typescript-eslint/camelcase */
import { defineComponent, onMounted } from "vue";
import {
  allChannels,
  fetchChannels,
  currentChannel,
  setCurrentChannel,
  createChannel,
  channelListener
} from "@/vuetils/useChannel";
export default defineComponent({
  name: "Channels",
  async setup() {
    onMounted(() => {
      channelListener.subscribe();
    });

    await fetchChannels();

    return { allChannels, createChannel, currentChannel, setCurrentChannel };
  }
});
